import {Component} from '@angular/core';

@Component({
  selector: 'ng-json-editor-widget-array-one-of',
  template: `
    <div>oneOf</div>
  `,
  styles: []
})
export class WidgetArrayOneOfComponent {

}
